import { createRouteRef, createSubRouteRef } from '@mainstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-marketplace',
});

export const searchHomepageRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/home',
});
export const dataProductRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/search/:id/*',
});

export const dataProductLegacyRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/products-catalog/:id/*',
});

export const outputPortRouteRef = createSubRouteRef({
  id: 'wb-marketplace:outputPort',
  parent: rootRouteRef,
  path: '/consumable-interface/:id/*',
});

export const dataContractsOverviewRouteRef = createSubRouteRef({
  id: 'wb-marketplace-data-contracts-overview',
  parent: rootRouteRef,
  path: '/data-contracts',
});

// route for the metadata graph
export const metadataGraph = createSubRouteRef({
  id: 'wb-marketplace-business-ontology-graph',
  parent: rootRouteRef,
  path: '/business-ontology-graph',
});

export const marketplaceSearchRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/search',
});

// route for the knowledge graph manager
export const knowledgeGraphManager = createSubRouteRef({
  id: 'wb-marketplace-knowledge-graph-manager',
  parent: rootRouteRef,
  path: '/business-concepts-map',
});
